import { createDeepEqualSelector } from "../utils";

import { networkRequestEntityAdapter } from "./request.adapter";
import { MAX_NETWORK_ITEMS } from "./consts";

import type { RootState } from "../types";

export const getUserAlertState = (state: RootState) => state.networkRequests;

const { selectAll: selectAllRequests } =
  networkRequestEntityAdapter.getSelectors(
    (state: RootState) => state.networkRequests,
  );

const selectResponses = (state: RootState) => state.networkResponses;

export const selectNetworkItems = createDeepEqualSelector(
  [selectAllRequests, selectResponses],
  (requests, responses) => {
    const result = [];
    for (
      let i = requests.length - 1;
      i >= Math.max(0, requests.length - MAX_NETWORK_ITEMS);
      i -= 1
    ) {
      const request = requests[i];
      const response = responses.entities[request.id];

      result.push({
        request,
        response,
      });
    }
    return result;
  },
);
